import { Link } from 'react-router-dom';
import { rankingVideos } from '@/mocks/home';

export default function RankingSection() {
  const top3 = rankingVideos.slice(0, 3);

  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-12 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-950">热门排行</h2>
            <p className="text-sm text-foreground-500 mt-1">实时热度排行，发现大家都在看</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-8">
          {top3.map((video, index) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="relative bg-background-100 rounded-xl p-5 group hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="absolute top-0 right-4">
                <span className={`text-5xl font-bold font-heading ${
                  index === 0 ? 'text-primary-500/25' : index === 1 ? 'text-accent-500/25' : 'text-secondary-500/25'
                }`}>
                  {video.rank}
                </span>
              </div>
              <div className="relative z-10">
                <div className={`w-8 h-8 flex items-center justify-center rounded-full text-white text-xs font-bold mb-3 ${
                  index === 0 ? 'bg-primary-500' : index === 1 ? 'bg-accent-500' : 'bg-secondary-500'
                }`}>
                  {video.rank}
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {video.title}
                </h3>
                <span className="inline-block px-2 py-0.5 text-xs rounded-full bg-background-200 text-foreground-600 mt-2 whitespace-nowrap">
                  {video.category}
                </span>
                <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-star-fill text-accent-500 text-xs"></i>
                    </div>
                    {video.rating}
                  </span>
                  <span>{video.views.toLocaleString()}次播放</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="bg-background-100 rounded-xl p-4 md:p-5">
          {rankingVideos.slice(3).map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="flex items-center gap-4 py-3 border-b border-background-200/70 last:border-b-0 hover:bg-background-200/40 transition-colors rounded-lg px-3 -mx-3 cursor-pointer"
            >
              <span className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold ${
                video.rank <= 5 ? 'bg-primary-100 text-primary-700' : 'bg-background-200 text-foreground-500'
              }`}>
                {video.rank}
              </span>
              <span className="flex-1 text-sm text-foreground-800 font-medium line-clamp-1">
                {video.title}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{video.category}</span>
              <span className="text-xs text-foreground-500 flex items-center gap-1 whitespace-nowrap">
                <div className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                </div>
                {video.rating}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}